const versions = {
    CLI: '0.2.7',
}

export default versions